import LocaleNavLink from "./LocaleNavLink";
export default LocaleNavLink;
